import {
  BaSeContainer,
  BaSeParagraph,
  BaSeSmall1,
  BaSeTheme,
} from '@base/react';
import * as React from 'react';
import { cpfMask } from '../../../../utils/formatters/cpfMask';
import { phoneMask } from '../../../../utils/formatters/phoneMask';
import { VerticalAlign } from './data-table-styled';

export const PersonalData = ({ props }) => {
  return (
    <BaSeContainer>
      <VerticalAlign>
        <BaSeParagraph
          isBold={true}
          color={BaSeTheme.colors.institucionais.cinzaSebrae45}
        >
          {props.candidate.name}
        </BaSeParagraph>
        <BaSeSmall1 color={BaSeTheme.colors.institucionais.cinzaSebrae60}>
          {cpfMask(props.candidate.cpf)} / {phoneMask(props.phone ?? '')}
        </BaSeSmall1>
        <BaSeSmall1 color={BaSeTheme.colors.institucionais.cinzaSebrae60}>
          {props?.email}
        </BaSeSmall1>
      </VerticalAlign>
    </BaSeContainer>
  );
};
